import { modals } from "@mantine/modals";
import { Select, Stack, Button, Text } from "@mantine/core";
import { useState } from "react";

export const openExportModal = (giveawayId, exportParticipants) => {
  modals.open({
    title: "Export Participants",
    children: (
      <ExportModalContent
        giveawayId={giveawayId}
        exportParticipants={exportParticipants}
      />
    ),
  });
};

const ExportModalContent = ({ giveawayId, exportParticipants }) => {
  const [statusFilter, setStatusFilter] = useState("all");

  const handleExport = () => {
    exportParticipants({
      format: "csv",
      id: giveawayId,
      statusFilter,
    });
    modals.closeAll();
  };

  return (
    <Stack gap="md">
      <Text size="sm">Select which participants to export:</Text>

      <Select
        label="Status Filter"
        value={statusFilter}
        onChange={setStatusFilter}
        data={[
          { value: "all", label: "All Participants" },
          { value: "in-progress", label: "In Progress" },
          { value: "completed", label: "Completed" },
        ]}
        allowDeselect={false}
      />

      <Button onClick={handleExport} fullWidth>
        Export CSV
      </Button>
    </Stack>
  );
};
